import axios from 'axios';
import { authHeader } from './authservice/auth-header';

const API_URL = process.env.VUE_APP_BASE_API_URL;
const API_URL_N8N = 'http://10.10.30.233:5678/webhook/ahn-check-status';

class QueueService {
    list() {
        return axios.get(API_URL + 'malware/queue-analysis', { headers: authHeader() });
    }
    detail(data) {
        return axios.post(API_URL + 'malware/queue-analysis/detail', data, { headers: authHeader() });
    }
    update(data) {
        return axios.put(API_URL + 'malware/queue-analysis/update', data, { headers: authHeader() });
    }
    n8ncheck(data) {
        return axios.post(API_URL_N8N, data);
    }
}

export default new QueueService();
